import { useSelector } from "react-redux";

import { selectCurrentAllocation } from "fond/api";
import { UserRole, UserRoles } from "fond/types";

/**
 * Check whether the current user has the minimum required role to perform an action
 *
 * @param requiredRole The minimum role required to perform the action
 */
export function useRoleCheck(requiredRole: UserRole): boolean {
  const allocation = useSelector(selectCurrentAllocation);
  const role = UserRoles[allocation?.Role ?? "member"];
  return role >= UserRoles[requiredRole];
}
